import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

interface Props {
  className?: string;
}

const SapLogo = (props: Props) => {
  const { className } = props;

  return (
    <SvgIcon className={className} viewBox="0 0 24 24">
      <path d="M7.86 5.35L1 18.72 9.51 6.84 7.86 5.35zM12 4.9L1 19.1 14.28 7.83 12 4.9zM18.23 12.93a.66.66 0 01-.05-.61.67.67 0 01.22-.28l.07-.05a.62.62 0 01.32-.09.64.64 0 01.46.21l1.35 1.55h1v-5a.46.46 0 01.33-.44.51.51 0 01.42.06 3 3 0 00-.72-.44 6.17 6.17 0 00-.83-.37 6.44 6.44 0 00-2.68-.37h-.44a6.42 6.42 0 00-2.1.9l-.22.15-.09.06-.07.05L1.46 19.1 12 15.55l11 3.54z" />
    </SvgIcon>
  );
};

export default SapLogo;
